import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

/**
 * /environment/audit/** → /compliance/audit/** keeping the tail and the query.
 * Declared in app.routes.ts OUTSIDE the Environment guard (round 2, Review Focus 2):
 * a tenant that holds Compliance but not Environment still reaches its bookmarks.
 */
export const legacyAuditRedirect: RedirectFunction = ({ url, queryParams, fragment }) => {
  const router = inject(Router);
  return router.createUrlTree(['/compliance', 'audit', ...url.map(s => s.path)], { queryParams, fragment: fragment ?? undefined });
};
